import type { StaticEntityType } from "@config";
import { Combo } from "@library-containers/layers";
import { SlideView } from "./Slide.view";

export const SlideLibrary = ({ entity }: { entity: StaticEntityType }) => (
  <SlideView
    entity={{
      ...entity,
      settings: {
        ...entity.settings,
      },
    }}
  >
    {entity.children.map((child) => (
      <Combo key={child.id} entity={child} />
    ))}
  </SlideView>
);
